import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

/**
 * Props:
 * - show (bool)
 * - onHide (func)
 * - selectedDateKey (string 'YYYY-MM-DD')
 * - blockedItem (optional) -> an existing blocked item to display
 * - readOnly (optional bool)  // kept for compatibility, but fields are display-only
 *
 * NOTE: All block/unblock handlers and API calls were removed.
 */

const BlockDateModal = ({ show, onHide, selectedDateKey, blockedItem, readOnly }) => {
  const [reason, setReason] = useState("");
  const [isHoliday, setIsHoliday] = useState(false);

  useEffect(() => {
    if (!show) {
      setReason("");
      setIsHoliday(false);
      return;
    }

    if (blockedItem) {
      setReason(blockedItem.notes || blockedItem.reason || "");
      setIsHoliday(
        typeof blockedItem.isHoliday === "boolean"
          ? blockedItem.isHoliday
          : !!blockedItem.holiday
      );
    } else {
      setReason("");
      setIsHoliday(false);
    }
  }, [show, blockedItem]);

  const prettyDate = (() => {
    if (!selectedDateKey) return "";
    try {
      const parts = selectedDateKey.split("-");
      if (parts.length !== 3) return selectedDateKey;
      const year = Number(parts[0]);
      const month = Number(parts[1]) - 1; // JS months 0-11
      const day = Number(parts[2]);
      const dt = new Date(year, month, day);
      if (isNaN(dt.getTime())) return selectedDateKey;
      return dt.toLocaleDateString(undefined, {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
    } catch {
      return selectedDateKey;
    }
  })();

  // main modal visible (no confirm dialogs anymore)
  const mainModalVisible = Boolean(show);

  return (
    <Modal show={mainModalVisible} onHide={onHide} centered>
      <Form onSubmit={(e) => e.preventDefault()}>
        <Modal.Header closeButton>
          <Modal.Title>{blockedItem ? "Date Blocked" : prettyDate || selectedDateKey}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-2">
            <Form.Label>Reason</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder={blockedItem ? "" : "—"}
              disabled={true} // display-only
            />
          </Form.Group>

          <Form.Group>
            <Form.Check
              type="checkbox"
              id="holiday-check"
              label="Holiday"
              checked={isHoliday}
              onChange={(e) => setIsHoliday(e.target.checked)}
              disabled={true} // display-only
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default BlockDateModal;
